import type { RezaOpravneni, User } from './store.types';

export const allowedUserKeys: (keyof User)[] = [
	'loa',
	'typ_prihlaseni',
] as const;

export const allowedActiveRezaKeys: (keyof RezaOpravneni)[] = [
	'kod',
	'kodSablony',
	'nazevSablony',
	'platnostDo',
	'platnostOd',
	'postupitelny',
	'role',
	'rozsah',
	'seznamPostoupeni',
	'stav',
	'typ',
	'zastupujiciOsobaTyp',
] as const;
